let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("birrM")).then(() => parcelRequire('9aBYD'));